import * as action from '../types/actions'
import * as getter from '../types/getters'

export { action }
export { getter }



// WEBPACK FOOTER //
// ./resources/assets/js/store/types/index.js